import { withRouter } from '@atlassian/react-resource-router';
import LastVisitedProjectPageRedirect from './view.tsx';

export default withRouter(LastVisitedProjectPageRedirect);
